import React, { Fragment } from "react";
import { useObjectState } from "./ObjectProvider";
import sanitizeHtml from "sanitize-html";

export const renderSingle = (label, description) => (
  <ObjectProperty label={label} value={description || "N/A"} />
);

export const renderList = (label, items) => (
  <ObjectProperty label={label}>
    <ul className="o-prop__list">
      {items.map((item, j) => (
        <li key={j}>{item}</li>
      ))}
    </ul>
  </ObjectProperty>
);

const renderProp = (obj, prop) => {
  //if property has own render fn, use!
  if (prop.hasOwnProperty("render")) {
    return prop.render({ obj, prop });
  }

  //auto render property, but only if prop key isset on obj
  if (!obj.hasOwnProperty(prop.key) && !obj[prop.key]) {
    return null;
  }

  //auto render as list when more than one item found
  if (obj[prop.key].length > 1) {
    return renderList(prop.label || prop.key, obj[prop.key]);
  }

  // Round numbers to integers
  if (!isNaN(obj[prop.key][0])) {
    return renderSingle(prop.label || prop.key, Math.round(obj[prop.key][0]));
  }

  return renderSingle(prop.label || prop.key, obj[prop.key][0]);
};

export const propertyCount = ({ obj, prop }) => {
  if (!obj.hasOwnProperty(prop.key)) {
    //render nothing when prop not present
    return null;
  }
  return (
    <ObjectProperty
      label={prop.label || prop.key}
      value={obj[prop.key].length}
    />
  );
};

const sanitize = (dirty) => ({
  __html: sanitizeHtml(dirty, {
      // Only support basic markup
      allowedTags: [ 'b', 'i', 'em', 'strong' ]
  })
})

export const ObjectProperty = ({ label, value, html, children }) => (
  <Fragment key={label}>
    <dt className="o-prop__label">{label}</dt>
    {( html ?
      <dd className="o-prop__value" dangerouslySetInnerHTML={sanitize(value)} />
      :
      <dd className="o-prop__value">{children || value}</dd>
    )}
  </Fragment>
);

export const ObjectPropertyList = ({ children, properties }) => {
  const obj = useObjectState();

  const children_ =
    children ||
    properties.map((prop, idx) => (
      <Fragment key={idx}>{renderProp(obj, prop)}</Fragment>
    ));

  return <dl className="o-props">{children_}</dl>;
};
